import { render, staticRenderFns } from "./CompareMetricSection.vue?vue&type=template&id=0214585d&scoped=true"
import script from "./CompareMetricSection.vue?vue&type=script&lang=js"
export * from "./CompareMetricSection.vue?vue&type=script&lang=js"
import style0 from "./CompareMetricSection.vue?vue&type=style&index=0&id=0214585d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214585d",
  null
  
)

export default component.exports